<template>
	<div id="top">
		<div class="topBox" :style="'margin-top:'+(playHeight+pieceHeight) + 'px'">
			<div class="scroll">
				<div class="news">
					<img src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/toupiao/horn.png">
					<span>分销动态：</span>
				</div>
				<div class="scrollList">
					<ul :style="{ top }" v-if="news.length">
						<li v-for="item in news">{{item.nick}} 获得了 <span>{{item.money/100}}</span> 元分享收益</li>
					</ul>
					<ul :style="{ top }" v-else>
						<li>暂无数据</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import tool from '../../kits/Tools.js';

	export default {
		data() {
			return {
				ds_id:'',
				news:[],
				giftName:'',
				activeIndex: 0,
			}
		},
		computed: {
			top() {
			  return - this.activeIndex * 24 + 'px';
			}
		},
		props:['playHeight','pieceHeight','fans_id'],
		mounted() {
			var that = this;
			this.ds_id = tool.getQueryDsId();
			this.getBuyList();
			// setInterval(function(){
			// 	that.getBuyList();
			// },100000)

			setInterval(function(){
			  if(that.activeIndex < that.news.length - 1) {
				that.activeIndex += 1;
			  } else {
				that.activeIndex = 0;
			  }
			}, 3000);
		},
		methods: {
			getBuyList(){
				var that = this;
				var url = tool.baseUrl1()+'/shop/order/get_buy_list';
				var option = 'fans_id='+this.fans_id+'&ds_id='+this.ds_id;
				//var option = 'fans_id=26&ds_id=6';
				
				this.axios.post(url,option).then(function(data){
					var data = data.data;
					if(data.code == 200){
						that.news = that.news.concat(data.data);
					}
				},function(res){
					console.log(res);
				})
			},
			moneyEnter(name,money){
				this.news.push({'nick':name,'money':money});
			},
		}
	}
</script>

<style scoped>
.topBox {
	position: absolute;
	width: 100%;
	left: 0;
	top: 56vw;
	overflow: hidden;
}
.scroll{
	height: 24px;
	background:rgba(220,29,0,0.8);
	line-height: 24px;
	display: flex;
	color:rgb(252,239,169);
	overflow: hidden;
}
.scroll .news{
	margin:0 5px;
	color: #f7c85d;
	display: flex;
}
.scroll .news img{
	width: 16px;
	height: 16px;
	margin-top: 4px;
	margin-right: 4px;
}
.scrollList{
	flex:1;position: absolute;
	overflow: hidden;
	height: 24px;
	top: 0;
	left: 94px;
	width: 100%;
}
.scrollList ul{
	position: absolute;
	transition:top 0.5s;
	width: 100%;
	height: 34px;
}
.scrollList ul span{
	color:rgb(252,239,169);
}
</style>